import React from 'react'

function ibdpadmission() {
  return (
    <div>
      <h1>IBDP Admission</h1>
    </div>
  )
}

export default ibdpadmission
